import { styled } from 'theme'

export const StyledCategoryList = styled.div`
  background-color: white;
`
